import { LocalStorageKeys, appLocalStorage } from "./appLocalStorage";
import { SessionStorageKeys, appSessionStorage } from "./appSessionStorage";
import { isNil, isNotBlank } from "./utils";

const setSelectedCompanyIdToStorage = (selectedCompanyId) => {
  appSessionStorage.setValue(SessionStorageKeys.selectedCompanyId, selectedCompanyId);
  appLocalStorage.setValue(LocalStorageKeys.selectedCompanyId, selectedCompanyId);
};

const selectCompanyFromUrl = () => {
  const params = new URLSearchParams(window.location.search);
  const companyId = params.get('companyId');
  if (!companyId) {
    return;
  }
  appSessionStorage.setValue(SessionStorageKeys.selectedCompanyId, companyId);
  params.delete('companyId');
  const search = params.toString();
  window.history.replaceState(
    window.history.state,
    '',
    `${window.location.pathname}${search ? `?${search}` : ''}${window.location.hash}`
  );
};

const getSelectedCompanyIdFromStorage = () => {
  let selectedCompanyId = appSessionStorage.getValue(SessionStorageKeys.selectedCompanyId);
  return !isNil(selectedCompanyId) ? selectedCompanyId : appLocalStorage.getValue(LocalStorageKeys.selectedCompanyId);
};

const isSelectedCompanyIdMissingInAnyStorage = () => {
  const inSession = appSessionStorage.getValue(SessionStorageKeys.selectedCompanyId);
  const inLocal = appLocalStorage.getValue(LocalStorageKeys.selectedCompanyId);
  return isNil(inSession) || isNil(inLocal);
};

const setSelectedCompanyPortalIdToStorage = (portalId) => {
  if (isNotBlank(portalId) && portalId != 'null') {
    appSessionStorage.setValue(SessionStorageKeys.portalId, portalId);
    appLocalStorage.setValue(LocalStorageKeys.portalId, portalId);
  }
};

const getSelectedCompanyPortalIdFromStorage = () => {
  let portalId = appSessionStorage.getValue(SessionStorageKeys.portalId);
  return !isNil(portalId) ? portalId : appLocalStorage.getValue(LocalStorageKeys.portalId);
};

export const selectedCompanyStorage = {
  selectCompanyFromUrl,
  setSelectedCompanyIdToStorage,
  getSelectedCompanyIdFromStorage,
  isSelectedCompanyIdMissingInAnyStorage,
  setSelectedCompanyPortalIdToStorage,
  getSelectedCompanyPortalIdFromStorage,
};